// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"757":"612efbe7","4772":"aae91f23","8133":"789c3ff9","8576":"ebe95d95","9378":"612efbe7"}[chunkId] + ".chunk.css";
};